import { AA_BRAND_NAME, BSM_BRAND_NAME } from "@ds-developer/constants";
import { Brand } from "@hubcapp/types";

export const getBrandName = (brand: Brand) => {
  if (brand === Brand.Aads) {
    return AA_BRAND_NAME;
  }

  return BSM_BRAND_NAME;
};
